import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Spinner, Table } from 'react-bootstrap';
import AddBankAccForm from '../Forms/AddBankAccForm';
import BankAccountOrder from './BankAccountOrder';
import { clearBankAccountsCache, getBankAccounts } from '../../services/BankAccountService';
import { handleError } from '../../utils/errorHandling';

const ManageBankAccountsSection = ({ onNotify }) => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const rows = await getBankAccounts();
      setAccounts(rows);
    } catch (e) {
      setError(handleError(e, 'ManageBankAccountsSection'));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const handleAdded = () => {
    clearBankAccountsCache();
    load();
    if (onNotify) onNotify('Bank account added successfully!');
  };

  return (
    <div>
      <h3 className="page-title">Manage bank accounts</h3>
      <p style={{ marginLeft: '8px', maxWidth: '720px' }}>
        Active accounts used across transfers and pays are listed below. Add an account or change display order.
      </p>
      {error && (
        <Alert variant="danger" dismissible onClose={() => setError('')}>
          {error}
        </Alert>
      )}
      {loading ? (
        <Spinner animation="border" role="status" className="m-3">
          <span className="visually-hidden">Loading…</span>
        </Spinner>
      ) : (
        <>
          <Table striped bordered hover responsive size="sm" className="mt-2">
            <thead>
              <tr>
                <th>Nickname</th>
                <th>Bank</th>
                <th>Fulfil</th>
                <th>In tracking</th>
              </tr>
            </thead>
            <tbody>
              {accounts.map((a) => (
                <tr key={a.id}>
                  <td>{a.nickname}</td>
                  <td>{a.bank}</td>
                  <td>{a.fulfil}</td>
                  <td>{a.include_in_tracking ? 'Yes' : 'No'}</td>
                </tr>
              ))}
            </tbody>
          </Table>

          <hr />
          <h4>Add a bank account</h4>
          <AddBankAccForm onSuccess={handleAdded} />

          <hr />
          <h4>Bank account order</h4>
          <BankAccountOrder />
        </>
      )}
    </div>
  );
};

export default ManageBankAccountsSection;
